export default __webpack_public_path__ + "static/9-coding-game-36130f3a7b53588fc996f790da503183.png";